import { render, staticRenderFns } from "./SameCourseCarousel.vue?vue&type=template&id=1cc1bfd4"
import script from "./SameCourseCarousel.vue?vue&type=script&lang=js"
export * from "./SameCourseCarousel.vue?vue&type=script&lang=js"
import style0 from "./SameCourseCarousel.vue?vue&type=style&index=0&id=1cc1bfd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports